import { DateTime } from "luxon";

export const getDateRangeForView = (
  currentDate: DateTime,
  viewType: "day" | "3-day" | "week" | "month" | "worker"
): { startDate: DateTime; endDate: DateTime } => {
  // Ensure we have a valid date
  const validDate = currentDate?.isValid ? currentDate : DateTime.now();

  const luxonDate = validDate;

  switch (viewType) {
    case "day":
    case "worker":
      return {
        startDate: luxonDate.startOf("day"),
        endDate: luxonDate.endOf("day"),
      };

    case "3-day":
      return {
        startDate: luxonDate.startOf("day"),
        endDate: luxonDate.plus({ days: 2 }).endOf("day"),
      };

    case "week":
      return {
        startDate: luxonDate.startOf("week"),
        endDate: luxonDate.endOf("week"),
      };

    case "month":
      return {
        startDate: luxonDate.startOf("month"),
        endDate: luxonDate.endOf("month"),
      };

    default:
      return {
        startDate: luxonDate.startOf("day"),
        endDate: luxonDate.endOf("day"),
      };
  }
};
